import { ITranslationItems } from './language.types';

export const TRACKING_LABELS: ITranslationItems = {
  errorMessage: {
    nl: 'Houston we hebben een probleem.',
    en: 'Houston, we have a problem.',
  },
};
